export const manifest = {
  screens: {
    scr_pbm94s: { name: "Dashboard Nasional", route: "/", position: {"x":160,"y":220} },
    scr_7jp0gg: { name: "Dashboard Regional", route: "/regional", position: {"x":1560,"y":220} },
    scr_bk2gr0: { name: "Laporan Intelijen", route: "/reports", position: {"x":160,"y":2200} },
    scr_2nvyve: { name: "Pusat Komando", route: "/command-center", position: {"x":2960,"y":220} },
    scr_kycbv8: { name: "Login & Onboarding", route: "/login", position: {"x":160,"y":4180} },
    scr_jyu5k6: { name: "Aplikasi Personel", route: "/mobile", position: {"x":1560,"y":6160} },
    scr_ez930x: { name: "KPI & Analitik", route: "/kpi", position: {"x":1560,"y":2200} },
    scr_pgovhy: { name: "Peringatan Dini", route: "/alerts", position: {"x":4360,"y":220} },
    scr_xxivwn: { name: "Personel — Daftar", route: "/personnel", state: {"personnelTab":"daftar"}, position: {"x":160,"y":6160} },
    scr_tdzmtz: { name: "Personel — Peta Nasional", route: "/personnel", state: {"personnelTab":"peta"}, position: {"x":2960,"y":6160} },
    scr_bokfz9: { name: "Personel — Eksekutif", route: "/personnel", state: {"personnelTab":"eksekutif"}, position: {"x":4360,"y":6160} },
    scr_mhkf57: { name: "Manajemen Pengguna", route: "/users", position: {"x":160,"y":8140} },
    scr_3fbxe7: { name: "Data Master", route: "/master-data", position: {"x":1560,"y":8140} },
    scr_kweum6: { name: "Pengaturan", route: "/settings", position: {"x":2960,"y":8140} },
    scr_s8qcge: { name: "Log Audit", route: "/audit-log", position: {"x":4360,"y":8140} },
    scr_b1dega: { name: "Mode Eksekutif", route: "/executive", position: {"x":5760,"y":220} },
    scr_im3173: { name: "Sistem Desain", route: "/design-system", position: {"x":5760,"y":8140} },
    scr_p8cndy: { name: "Pusat Notifikasi", route: "/notifications", position: {"x":7160,"y":220} },
    scr_i146k2: { name: "Akses Ditolak", route: "/unauthorized", position: {"x":0,"y":0}, isDefaultRow: true },
    scr_6bogmr: { name: "Penjabaran UK/STR", route: "/ukstr", position: {"x":160,"y":10120} },
    scr_bd3bd3: { name: "Form UK/STR", route: "/ukstr/new", position: {"x":1560,"y":10120} },
    scr_czfwq7: { name: "Monitoring Tugas UK/STR", route: "/ukstr/monitoring", position: {"x":2960,"y":10120} },
    scr_hum344: { name: "Jawaban Lapangan UK/STR", route: "/ukstr/answers", position: {"x":4360,"y":10120} },
  },
  sections: {
    sec_1gqxq6: { name: "Dashboard Views", x: 0, y: 0, width: 8520, height: 1180 },
    sec_d2r01d: { name: "Analytics", x: 0, y: 1980, width: 2920, height: 1180 },
    sec_yzrc57: { name: "Login & Onboarding", x: 0, y: 3960, width: 1520, height: 1180 },
    sec_8h2btc: { name: "Personnel Management", x: 0, y: 5940, width: 5720, height: 1180 },
    sec_8cf0lw: { name: "Administration", x: 0, y: 7920, width: 7120, height: 1180 },
    sec_h09iuy: { name: "UK/STR Management", x: 0, y: 9900, width: 5720, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_1gqxq6", children: [
      { kind: "screen", id: "scr_pbm94s" },
      { kind: "screen", id: "scr_7jp0gg" },
      { kind: "screen", id: "scr_2nvyve" },
      { kind: "screen", id: "scr_pgovhy" },
      { kind: "screen", id: "scr_b1dega" },
      { kind: "screen", id: "scr_p8cndy" },
    ] },
    { kind: "section", id: "sec_d2r01d", children: [
      { kind: "screen", id: "scr_bk2gr0" },
      { kind: "screen", id: "scr_ez930x" },
    ] },
    { kind: "section", id: "sec_yzrc57", children: [
      { kind: "screen", id: "scr_kycbv8" },
    ] },
    { kind: "section", id: "sec_8h2btc", children: [
      { kind: "screen", id: "scr_xxivwn" },
      { kind: "screen", id: "scr_jyu5k6" },
      { kind: "screen", id: "scr_tdzmtz" },
      { kind: "screen", id: "scr_bokfz9" },
    ] },
    { kind: "section", id: "sec_8cf0lw", children: [
      { kind: "screen", id: "scr_mhkf57" },
      { kind: "screen", id: "scr_3fbxe7" },
      { kind: "screen", id: "scr_kweum6" },
      { kind: "screen", id: "scr_s8qcge" },
      { kind: "screen", id: "scr_im3173" },
    ] },
    { kind: "screen", id: "scr_i146k2" },
    { kind: "section", id: "sec_h09iuy", children: [
      { kind: "screen", id: "scr_6bogmr" },
      { kind: "screen", id: "scr_bd3bd3" },
      { kind: "screen", id: "scr_czfwq7" },
      { kind: "screen", id: "scr_hum344" },
    ] },
  ],
}
